<!-- P7S1 Component - Section 1 - General Information on PFIC, QEF, or QIC -->
<div class="f1065-k2-container p7s1-container">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>
    
    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    <!-- FORM CONTENT -->
    @if (!showLoader) {
<div>
    
    <!-- Section Header -->
    <p class="section-header h5">
      <b>{{ sectionHeader }}</b>
    </p>
    
    <!-- Data Table -->
    <div class="table-responsive" style="position: relative; left: 1px; width: 100%; min-height: 700px;">
      <table class="table table-striped table-bordered table-hover k2-data-table">
        <thead>
          <tr>
            <!-- Error Column Header -->
            @if (showErrCol) {
<th class="err-col-header" style="width: 200px">Error</th>
}
            
            <!-- Line Number Column (includes Add/Delete buttons in body) -->
            <th class="pl-2" style="text-align: center">Line</th>
            
            <!-- Dynamic Column Headers -->
            @for (col of colHeaderData | orderBy:'COL_PRIORITY'; track trackByCol($index, col)) {
<th 
                style="width: 120px; text-align: center; vertical-align: top;">
              {{ col.COL_DESC }}
              @if (col.IS_MANDATORY === 'Y') {
<span>*</span>
}
              @if (col.IS_PREF_MANDATORY === 'Y') {
<span style="vertical-align: super;">+</span>
}
            </th>
}
          </tr>
        </thead>
        
        <tbody>
          <!-- Loop through grouped form lines -->
          @for (line of groupedFormLines | filterBy:'IS_DISPLAY':'Y' | orderBy:['LINE_ORDER', 'SNO']; track trackByLine($index, line)) {

            <tr>
              <!-- Error Column -->
              @if (showErrCol) {
<td style="text-align: center" class="err-col">
                <div [ngClass]="line.ERR_MSG && line.ERR_MSG.length > 0 ? 'err-cell-yes' : 'err-cell-no'"
                     [innerHTML]="line.ERR_MSG"></div>
              </td>
}
              
              <!-- Line Number with Add/Delete Buttons (combined, like original) -->
              <td class="pl-2" style="font-weight: bold; white-space: nowrap; padding-right: 5px; text-align: right;">
                <!-- Add Row Button -->
                @if (line.IS_LINE_MULTI === 'Y' && line.SNO === 0 && isAdmin) {
<i
                   style="font-size: 24px; cursor: pointer; vertical-align: middle;"
                   class="fa fa-plus-circle color-green"
                   ap-tooltip [tooltipContent]="'Add Row'"
                   [direction]="'top'" [appendAfterTarget]="true"
                   (click)="addRow(line)"></i>
}
                <!-- Delete Row Button -->
                @if (line.IS_LINE_MULTI === 'Y' && line.SNO !== 0 && isAdmin) {
<i
                   style="font-size: 24px; cursor: pointer; vertical-align: middle;"
                   class="fa fa-minus-circle color-red"
                   ap-tooltip [tooltipContent]="'Delete Row'"
                   [direction]="'top'" [appendAfterTarget]="true"
                   (click)="deleteRow(line)"></i>
}
                <!-- Line Number (only for SNO === 0) - P7S1 does NOT show LINE_DESC -->
                @if (line.SNO === 0) {
<span>{{ line.LINE_NO }}</span>
}
              </td>
              
              <!-- Data Cells -->
              @for (item of line.items | orderBy:'COL_ORDER'; track trackByItem($index, item)) {
<td
                  [ngClass]="{'has-error': item.IS_ERROR === 'Y'}">
                
                <!-- NUMERIC Input -->
                @if (item.UI_COMP === 'NUMERIC') {
<input
                       type="text"
                       class="form-control min-ele-wid"
                       [ngClass]="{
                         'custom-error': item.IS_ERROR === 'Y',
                         'custom-textbox': item.IS_ENABLED === 'Y' || item.IS_ENABLED === 'Z'
                       }"
                       [(ngModel)]="item.CELL_VALUE"
                       [disabled]="item.IS_ENABLED === 'N'"
                       onlyIntegersWithLength
                       (ngModelChange)="onNumericChange(line.items)"
                       style="text-align: right;">
}
                
                <!-- TEXT Input -->
                @if (item.UI_COMP === 'TEXT') {
<input
                       type="text"
                       class="form-control min-ele-wid"
                       [ngClass]="{
                         'custom-error': item.IS_ERROR === 'Y',
                         'custom-textbox': item.IS_ENABLED === 'Y' || item.IS_ENABLED === 'Z'
                       }"
                       [(ngModel)]="item.CELL_VALUE"
                       [disabled]="item.IS_ENABLED === 'N'"
                       [maxlength]="item.MAX_LENGTH || 255"
                       style="text-align: right;">
}
                
                <!-- DATE Input (enabled) -->
                @if (item.UI_COMP === 'DATE' && item.IS_ENABLED !== 'N') {
<div 
                     class="date-input-group">
                  <input type="date"
                         class="form-control min-ele-wid"
                         [ngClass]="{
                           'custom-error': item.IS_ERROR === 'Y',
                           'custom-textbox': item.IS_ENABLED === 'Y' || item.IS_ENABLED === 'Z'
                         }"
                         [ngModel]="item.CELL_VALUE | date:'yyyy-MM-dd'"
                         (ngModelChange)="onDateChange(item, $event)"
                         placeholder="yyyy-mm-dd"
                         style="font-size: 11px;">
                </div>
}
                
                <!-- DATE Input (disabled) -->
                @if (item.UI_COMP === 'DATE' && item.IS_ENABLED === 'N') {
<div 
                     class="date-input-group">
                  <input type="date"
                         class="form-control min-ele-wid"
                         [ngClass]="{
                           'custom-error': item.IS_ERROR === 'Y'
                         }"
                         [ngModel]="item.CELL_VALUE | date:'yyyy-MM-dd'"
                         disabled
                         readonly
                         placeholder="yyyy-mm-dd"
                         style="font-size: 11px;">
                </div>
}
                
                <!-- CHECKBOX -->
                @if (item.UI_COMP === 'CHK_BX') {
<div class="text-center">
                  <input type="checkbox"
                         [(ngModel)]="item.CELL_VALUE"
                         [disabled]="item.IS_ENABLED === 'N'"
                         [value]="'Y'">
                </div>
}
                
                <!-- DROPDOWN -->
                @if (item.UI_COMP === 'DROP_DOWN') {
<select
                        class="form-control min-ele-wid k2-select"
                        [ngClass]="{
                          'custom-error': item.IS_ERROR === 'Y',
                          'custom-textbox': item.IS_ENABLED === 'Y' || item.IS_ENABLED === 'Z'
                        }"
                        [(ngModel)]="item.CELL_VALUE"
                        [disabled]="item.IS_ENABLED === 'N'">
                  <option value="">--Select--</option>
                  @for (opt of item.actionData; track $index) {
<option 
                          [value]="opt.VALUE">
                    {{ opt.LABEL }}
                  </option>
}
                </select>
}
                
                <!-- LABEL (non-editable display) -->
                @if (!item.UI_COMP || item.UI_COMP === 'LABEL') {
<span>
                  {{ item.CELL_VALUE }}
                </span>
}
                
              </td>
}
            </tr>
          
}
        </tbody>
      </table>
    </div>
    
    <!-- Action Buttons -->
    @if (isAdmin) {
<div class="k2-buttons-container">
      <button class="save-button" type="button" (click)="save()" [disabled]="isSaveClicked">Save</button>
      <button class="reset-button" type="button" (click)="reset()" [disabled]="!isAdmin">Reset</button>
    </div>
}
    
    </div>
} <!-- closes content -->
  </div>
} <!-- closes !loadingData -->
  
  <!-- Confirmation Modal -->
  @if (showConfirmModal) {
<div class="confirmation-modal-overlay">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="false"
      (confirmed)="onSaveConfirm()"
      (cancelled)="onSaveCancel()"
      (closed)="onSaveCancel()">
    </gtw-confirmation-modal>
  </div>
}
  
</div>
